import toast from "react-hot-toast";

const toastHelper = {
  success: (message: string) => toast.success(message),
  error: (message: string) => toast.error(message),
};

export default toastHelper;
